import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const Button = styled.button`
    font-size: ${ds.fs('base')};
    font-family: ${ds.get('type.fontFamily.text')};
    font-weight: ${ds.get('type.fontWeight.light')};
    background-color: ${ds.get('colors.brand.product')};
    color: ${ds.get('colors.brand.background')};
    width: 200px;
    height: 65px;
    border: none;
    cursor: pointer;
    display: block;
    margin: ${ds.get('metrics.m')} auto;
    
    transition: background-color, .1s, ease-in-out;
    outline: none;
    
    &:hover, &:focus {
      background-color: ${ds.get('colors.brand.productHover')};
    }
    
    &:active {
      background-color: ${ds.get('colors.brand.productActive')};
    }
    
    ${media.desktop`
        margin-left: 0;
    `};
    

`;

export default Button;



// WEBPACK FOOTER //
// ./src/elements/Button.js